// extracted by mini-css-extract-plugin
export default {"wrapper":"employee_wrapper__I9fRY"};